<template>
	<div class="container d-flex flex-grow-1 flex-column align-items-center justify-content-center" style="height: 100vh;">
		<h3 class="font-weight-normal">
			Hi {{ invitation.user.first_name }}
		</h3>
		<h3 class="text-muted font-weight-normal">
			To finalise the setup of your account, please complete the form below.
		</h3>
		<div class="card mt-4">
			<div class="card-body">
				<form class="form-horizontal">
					<div class="form-group">
						<label>Password</label>
						<input class="form-control"
							type="password" :class="getValidationClass('password')"
							:value="form.password"
							@input="form.password = $event.target.value">
						<div class="invalid-feedback" v-html="getValidationErrors('password', true)">
						</div>
					</div>
					<div class="form-group">
						<label>Confirm Password</label>
						<input class="form-control"
							type="password" :class="getValidationClass('password_confirmation')"
							:value="form.password_confirmation"
							@input="form.password_confirmation = $event.target.value">
						<div class="invalid-feedback">
							{{ getValidationErrors('password_confirmation') }}
						</div>
					</div>
					<div class="form-group">
						<label>Phone</label>
						<input class="form-control"
							:class="getValidationClass('phone')"
							:value="form.phone"
							@input="form.phone = $event.target.value; formatPhone($event)">
						<div class="invalid-feedback">
							{{ getValidationErrors('phone') }}
						</div>
					</div>
					<div class="form-group">
						<label>Timezone</label>
						<select class="form-control"
							:class="getValidationClass('timezone')"
							:value="form.timezone"
							@change="form.timezone = $event.target.value">
							<optgroup v-for="(zones, country) in timezones" :key="country"
								:label="country">
								<option v-for="zone in zones" :key="zone"
									:value="`${country}/${zone}`">
									{{ zone }} ({{ getTimeInTimezone(country, zone) }})
								</option>
							</optgroup>
						</select>
						<div class="invalid-feedback">
							{{ getValidationErrors('timezone') }}
						</div>
					</div>
					<div class="form-group mb-0">
						<label class="checkbox-inline" :class="getValidationClass('agree_terms')">
							<input type="checkbox"
								name="agree_terms"
								:checked="form.agree_terms"
								@change="form.agree_terms = $event.target.checked"> I confirm my agreement to Absolute Domestics
							<a target="_blank" href="/terms-and-conditions.pdf">Terms and Conditions</a>
							of Registration and
							<a target="_blank" href="https://absolutedomestics.com.au/privacy-policy">Privacy Policy</a>
						</label>
						<div class="invalid-feedback">
							{{ getValidationErrors('agree_terms') }}
						</div>
					</div>
				</form>
			</div>
			<div class="card-footer d-flex justify-content-end">
				<button class="btn btn-primary float-right" @click="submit">
					Continue
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import { useValidation } from '@js/composables/useValidation.js';

	const timezones = {
		['Australia']: [
			'Adelaide',
			'Brisbane',
			'Broken Hill',
			'Darwin',
			'Eucla',
			'Hobart',
			'Lindeman',
			'Lord Howe',
			'Melbourne',
			'Perth',
			'Sydney'
		],
		['New Zealand']: [
			'Auckland',
			'Chatham',
		]
	}

	import { AsYouType } from 'libphonenumber-js'

	export default {
		props: {
			token: {
				required: true,
				default: () => '',
				type: String,
			}
		},
		setup() {
			return {
				...useValidation(),
			};
		},
		data() {
			return {
				form: {
					password: null,
					password_confirmation: null,
					phone: null,
					timezone: null,
					agree_terms: null,
				},
				invitation: null,
				timezones
			}
		},
		mounted() {
			this.getInvitation();
		},
		methods: {
			getInvitation() {
				this.$axios.get(`/api/invitations/${this.token}`).then((response) => {
					this.invitation = response.data.data;
				}).catch(() => {
					alert('An error occurred while fetching the invitation');
				});
			},
			getTimeInTimezone(country, city) {
				if (country === 'New Zealand') {
					country = 'Pacific';
				}

				let options = {
					timeZone: `${country.replace(/ /g, '')}/${city.replace(/ /g, '_')}`,
					hour: 'numeric',
					minute: 'numeric',
					second: 'numeric',
				};

				let formatter = new Intl.DateTimeFormat([], options);

				return formatter.format(new Date());
			},
			submit() {
				this.$axios.post(`/api/invitations/accept/${this.token}`, {
					password: this.form.password,
					password_confirmation: this.form.password_confirmation,
					phone: this.form.phone,
					timezone: this.form.timezone,
					agree_terms: this.form.agree_terms,
				}).then(() => {
					this.$router.push('/');
				}).catch(this.handleError);
			},
			formatPhone() {
				const formatted = new AsYouType((this.invitation.country ?? 'au').toUpperCase()).input(this.form.phone)

				this.form.phone = formatted
			}
		}
	}
</script>
